<div class="destination-container">
  <div class="sub-item-title">Destination</div>

  <div class="destination">
    <div  *ngIf="isUserGroupsExists(item.destination)">
      <div class="sub-title">User Groups:</div>
      <div class="sub-item">
                <span *ngFor="let userGroup of item.destination.userGroups; let last=last;">
                    <span>&nbsp;{{userGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                </span>
      </div>
    </div>

    <div *ngIf="isRRAttributesExists(item.destination, 'general')">
      <div *ngIf="isRRAttributesExists(item.destination, 'host')">
        <div class="sub-title">Hosts:</div>
        <div class="sub-item">
                    <span *ngFor="let host of item.destination.rrAttrs.attributes.host; let last=last;">
                        <span>&nbsp;{{host}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                    </span>
        </div>
      </div>

      <div *ngIf="isRRAttributesExists(item.destination, 'prefix')">
        <div class="sub-title">Prefixes:</div>
        <div class="sub-item">
                    <span *ngFor="let prefix of item.destination.rrAttrs.attributes.prefix; let last=last;">
                        <span>&nbsp;{{prefix}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                    </span>
        </div>
      </div>

      <div *ngIf="isRRAttributesExists(item.destination, 'prefixGroups')">
        <div class="sub-title">Prefix Groups:</div>
        <div class="sub-item">
                    <span *ngFor="let prefixGroup of item.destination.rrAttrs.attributeGroups; let last=last;">
                        <span>&nbsp;{{prefixGroup.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
                    </span>
        </div>
      </div>

      <div *ngIf="isCustomersExists(item.destination)">
          <div class="sub-title">Customers:</div>
          <div class="sub-item">
            <span *ngFor="let customer of item.destination.destCustomers; let last=last;">
                <span>&nbsp;{{customer.name}}&nbsp;<span *ngIf="!last">&bull;</span></span>
            </span>
          </div>
      </div>

      <div *ngIf="useAllCustomers(item.destination)">
          <div class="sub-title">Customers:</div>
            <div class="sub-item">
              <span>Use All Customers</span>
            </div>
        </div>
    </div>
  </div>

</div>
